import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_3487_1957)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3487_1957" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "19.33",
      height: "19.33",
      fill: "white",
      transform: "translate(0.799805)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentInputIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 21,
  },
  height: {
    type: Number as PropType<number>,
    default: 20,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "!tw-w-[19px] !tw-h-[19px]"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M12.0078 12.0744C11.8555 12.2296 11.6731 12.3521 11.4718 12.4344L8.63984 13.5624C8.34907 13.6788 8.03055 13.7073 7.72374 13.6443C7.41694 13.5814 7.13535 13.4298 6.91389 13.2084C6.69243 12.9869 6.54083 12.7053 6.4779 12.3985C6.41496 12.0917 6.44345 11.7732 6.55984 11.4824L7.68784 8.65841C7.77495 8.4554 7.89983 8.2708 8.05584 8.11441L12.7598 3.41041C12.7884 3.3829 12.8081 3.34754 12.8165 3.30881C12.8249 3.27007 12.8216 3.22972 12.8071 3.19286C12.7925 3.156 12.7673 3.1243 12.7347 3.10178C12.702 3.07927 12.6635 3.06696 12.6238 3.06641H3.55184C2.88986 3.06641 2.25499 3.32938 1.7869 3.79747C1.31881 4.26556 1.05584 4.90043 1.05584 5.56241V16.5704C1.05584 17.2324 1.31881 17.8673 1.7869 18.3353C2.25499 18.8034 2.88986 19.0664 3.55184 19.0664H14.5598C15.2218 19.0664 15.8567 18.8034 16.3248 18.3353C16.7929 17.8673 17.0558 17.2324 17.0558 16.5704V7.50641C17.0553 7.46677 17.043 7.4282 17.0205 7.39558C16.9979 7.36296 16.9663 7.33776 16.9294 7.32319C16.8925 7.30862 16.8522 7.30532 16.8134 7.31373C16.7747 7.32214 16.7393 7.34186 16.7118 7.37041L12.0078 12.0744Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M15.7567 2.65784C15.6801 2.58354 15.5775 2.54199 15.4708 2.54199C15.364 2.54199 15.2615 2.58354 15.1848 2.65784L8.89454 8.9562C8.85376 8.99023 8.82312 9.03481 8.80595 9.08507L7.66225 11.9362C7.63381 12.0096 7.62704 12.0896 7.64275 12.1667C7.65846 12.2438 7.69598 12.3148 7.75085 12.3712C7.80871 12.4236 7.87963 12.4595 7.95616 12.4751C8.03269 12.4907 8.112 12.4854 8.18577 12.4598L11.0369 11.3161C11.0887 11.2973 11.1356 11.267 11.1739 11.2275L17.4642 4.93717C17.5393 4.86233 17.5826 4.76131 17.585 4.65527C17.583 4.54678 17.5398 4.44311 17.4642 4.36532L15.7567 2.65784Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M19.4536 2.93976C19.7536 2.63795 19.922 2.22968 19.922 1.80412C19.922 1.37856 19.7536 0.970291 19.4536 0.668481C19.304 0.518711 19.1263 0.399898 18.9307 0.318834C18.7352 0.23777 18.5256 0.196045 18.3139 0.196045C18.1022 0.196045 17.8926 0.23777 17.697 0.318834C17.5015 0.399898 17.3238 0.518711 17.1742 0.668481L16.3285 1.52222C16.2566 1.59919 16.2138 1.69893 16.2077 1.80412C16.2071 1.85693 16.2175 1.9093 16.2383 1.95785C16.2591 2.0064 16.2899 2.05006 16.3285 2.08601L18.036 3.7935C18.072 3.83219 18.1156 3.86292 18.1642 3.88373C18.2127 3.90454 18.2651 3.91495 18.3179 3.91431C18.423 3.90754 18.5225 3.86489 18.5998 3.7935L19.4536 2.93976Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6
  ], 8, _hoisted_1))
}
}

})